// @flow
import React from 'react';

import { COLUMN_3 } from 'Components/frameworks/card/Card.constants';
import { mapColToCard } from 'Components/utils/cards/cards.utils';

import { Card } from 'Components/frameworks/card/Card.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  columns: Array<CMSCard>,
  config: CMSContent,
  id?: string,
};

export function MediaThumbnailLine({ columns = [], config, id }: Props) {
  if (!columns.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      <div className="sm:flex -m-2">
        {columns.map(col => (
          <div className="p-2 sm:w-1/3" key={col.title}>
            <Card
              {...mapColToCard({ ...col, config })}
              className="h-full"
              layout={COLUMN_3}
              theme="thumbnail"
            />
          </div>
        ))}
      </div>
    </SiteContainer>
  );
}
